import { render, staticRenderFns } from "./reccostdetail.vue?vue&type=template&id=0c4b9f71&scoped=true&"
import script from "./reccostdetail.vue?vue&type=script&lang=js&"
export * from "./reccostdetail.vue?vue&type=script&lang=js&"
import style0 from "./reccostdetail.vue?vue&type=style&index=0&id=0c4b9f71&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4b9f71",
  null
  
)

export default component.exports